import React from 'react';

export interface TooltipSectionProps {
  header: string;
  children: React.ReactNode;
}

const TooltipSection = ({ header, children }: TooltipSectionProps) => (
  <div className="tooling-tooltip__section">
    <span className="tooling-tooltip__section-header">{header}</span>
    {children}
  </div>
);

TooltipSection.displayName = 'ToolingCoverageTooltip.Section';

export default TooltipSection;
